<style lang="scss" scoped>
$leftWidth: 220px;
.content-part {
  .content-left {
    width: 0;
  }

  .content-right {
    > h3 {
      left: 0;
    }

    left: 0;
  }
}

.el-checkbox--upload {
  position: absolute;
  left: 100px;
  top: 0;
  display: block;
}

.waring-tag {
  position: absolute;
  top: 0;
  left: 70px;
  padding-left: 10px;
  margin-bottom: 5px;
}
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>上传业务数据XML</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="120px" style="padding-right: 20px">
            <el-form-item label="货主" prop="sourceOrgId"
                          :rules="[{required: true, message: '请选择货主', trigger: 'change'}]">
              <org-select :remote-method="queryUpAllFactory" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索货主`"
                          v-model="form.sourceOrgId" :list="allOrgList"/>
            </el-form-item>
            <el-form-item label="往来单位" prop="businessOrgId"
                          :rules="[{required: true, message: '请选择往来单位', trigger: 'change'}]">
              <org-select :remote-method="queryBizOrgList" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索往来单位`"
                          v-model="form.businessOrgId" :list="bizOrgList" @change="setDirectOrgId"/>
            </el-form-item>
            <el-form-item label="物流方式">
              <el-select type="text" v-model="form.transportationMode"
                         placeholder="请选择物流方式" clearable>
                <el-option :value="item.label" :key="item.key" :label="item.label"
                           v-for="item in transportationMeansList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输条件">
              <el-select type="text" v-model="form.logisticsCondition" placeholder="请选择运输条件" clearable>
                <el-option :value="item.label" :key="item.key" :label="item.label"
                           v-for="item in transportationConditionList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作单位">
              <org-select :remote-method="queryCallAllFactory" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索操作单位`"
                          v-model="form.operateOrgId" :list="callOrgList"/>
            </el-form-item>
            <el-form-item label="上传文件" style="position: relative">
              <oms-upload-relation uploadUrl="/qingstor/code/pre" deleteUrl="/code-upload/file" :multiple="false"
                                   :fileList="fileList" :formData="{objectType:'traceCodeByOrg'}"
                                   accept="xml"
                                   @change="changeFiles" @isProgress="onUploadProgress"
                                   :clearUploadFiles="clearUploadFiles"
                                   @refreshCodes="setIsUploading"></oms-upload-relation>
              <el-tag class="mt-10" v-show="uploading" type="warning">正在上传文件, 请勿关闭窗口</el-tag>
              <div class="waring-tag">
                <i class="el-icon-warning"></i> 请选择单个文件上传
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :disabled="doing" v-show="!uploading&&analysisComplete">保存
              </el-button>
              <el-button type="default" @click="analysis" :disabled="analysisDoing"
                         v-show="!uploading&&!analysisComplete">解析
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';

export default {
  props: ['defaultIndex'],
  mixins: [methodsMixin],
  data() {
    return {
      form: {
        sourceOrgId: '',
        sourceOrgName:'',
        businessOrgId: '',
        directOrgId: '',
        directOrgName: '',
        logisticsCondition: '',
        transportationMode: '',
        operateOrgId: '',
        fileId: ''
      },
      rules: {},
      doing: false,
      analysisDoing: false,
      analysisComplete: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: []
    };
  },
  computed: {
    uploading() {
      if (!this.uploadingFiles) {
        return false;
      }
      return this.uploadingFiles.some(val => val.isUploading);
    },
    transportationConditionList: function () {
      return this.$getDict('transportationCondition');
    },
    transportationMeansList: function () {
      let a = this.$getDict('outTransportMeans');
      if (a) {
        a = JSON.parse(JSON.stringify(a));
      }
      a && a.forEach(i => {
        i.key = i.key + '1_';
      });
      let b = this.$getDict('transportationMeans');
      if (b) {
        b = JSON.parse(JSON.stringify(b));
      }
      b && b.forEach(i => {
        i.key = i.key + '2_';
      });
      let ary = [];
      if (a && b) {
        ary = a.concat(b);
      }
      return ary;
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
      // 设置货主和操作单位
      let org = JSON.parse(window.localStorage.getItem('org'));
      let tempOrg = {
        id: org.id,
        name: org.name
      }
      this.callOrgList = [tempOrg];
      this.allOrgList = [tempOrg];
      this.form.sourceOrgId = org.id;
      this.form.sourceOrgName=org.name;
      this.form.operateOrgId = org.id;
    },
    uploading() {
      if (!this.uploadingFiles) {
        return false;
      }
      return this.uploadingFiles.some(val => val.isUploading);
    }
  },
  methods: {
    setIsUploading(file) {
      this.uploadingFiles.forEach(val => {
        if (file.uid === val.uid) {
          val.isUploading = false;
        }
      })
    },
    setDirectOrgId(val) {
      if (!val) return;
      let list = this.bizOrgList.filter(v => v.id === val);
      if (list && list[0]) {
        this.form.directOrgId = list[0].businessOrgId;
        this.form.directOrgName=list[0].name;
      }
    },
    onUploadProgress(file) {
      let containFlag = this.uploadingFiles.some(value => value.uid === file.uid);
      if (!containFlag) {
        let newFile = Object.assign({}, file, {isUploading: true});
        this.uploadingFiles.push(newFile);
      }
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
      if (this.form.attachmentIdList && this.form.attachmentIdList.length) {
        this.analysis();
      }
    },
    clearUploadFiles() {
      this.uploadingFiles = [];
    },
    goodsChange(val) {
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        sourceOrgId: '',
        sourceOrgName:'',
        directOrgId: '',
        directOrgName: '',
        logisticsCondition: '',
        transportationMode: '',
        operateOrgId: '',
        fileId: ''
      };
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.analysisComplete = false;
      this.uploadingFiles = [];
      this.bizOrgList=[];
    },
    analysis() {
      if (!this.form.attachmentIdList.length) {
        return this.$notify.info({message: '请上传文件'});
      }
      if (this.form.attachmentIdList.length > 1) {
        return this.$notify.info({message: '请上传单个文件'});
      }
      this.form.fileId = this.form.attachmentIdList[0];
      let form = JSON.parse(JSON.stringify(this.form));
      delete form.attachmentIdList;
      this.analysisDoing = true;
      http.post('/code-biz/ali-file/parse-org', form).then(res => {
        this.analysisDoing = false;
        this.analysisComplete = true;
        if (!res.data.id||!res.data.name) {
          return;
        }
        this.form.directOrgName = res.data.name;
        this.form.businessOrgId = res.data.id;
        this.form.directOrgId = res.data.id;
        if (res.data.id) {
          this.bizOrgList = [
            {id: res.data.id, name: res.data.name}
          ];
        }
      }).catch(e => {
        this.$notify.error({
          duration: 2000,
          message: e.response && e.response.data && e.response.data.msg || '解析失败'
        });
        this.analysisDoing = false;
      });
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        if (!this.form.attachmentIdList.length) {
          return this.$notify.info({message: '请上传文件'});
        }
        if (this.form.attachmentIdList.length > 1) {
          return this.$notify.info({message: '请上传单个文件'});
        }
        this.form.fileId = this.form.attachmentIdList[0];
        if (!this.form.directOrgId) {
          this.form.directOrgId = this.form.businessOrgId;
        }
        let form = JSON.parse(JSON.stringify(this.form));
        delete form.attachmentIdList;
        this.doing = true;
        http.post('/code-biz/ali-file', form).then(res => {
          this.$emit('refresh', {id: res.data});
          this.resetForm();
          this.doing = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '解析失败'
          });
          this.doing = false;
        });
      });
    }
  }
};
</script>
